import React, { useLayoutEffect, useRef } from 'react'

const AutoGrowTextarea = ({
	className,
	value,
	onChange,
	minHeight = 24,
	...props
}) => {
	const textareaRef = useRef(null)

	useLayoutEffect(() => {
		const element = textareaRef.current
		if (!element) return
		element.style.height = `${minHeight}px`
		element.style.height = `${Math.max(element.scrollHeight, minHeight)}px`
	}, [minHeight, value])

	return (
		<textarea
			ref={textareaRef}
			className={className}
			value={value}
			onChange={onChange}
			rows={1}
			{...props}
		/>
	)
}

export default AutoGrowTextarea
